const OS_LOW_RISK_DATA = [
  {
    t: 0.0,
    s: 1.0,
    lower: 1.0,
    upper: 1.0,
  },
  {
    t: 2.6,
    s: 0.988372093,
    lower: 0.9203217436,
    upper: 0.9983538298,
  },
  {
    t: 4.6,
    s: 0.976744186,
    lower: 0.9102024361,
    upper: 0.9941325471,
  },
  {
    t: 5.7,
    s: 0.9651162791,
    lower: 0.895746803,
    upper: 0.9886143262,
  },
  {
    t: 6.5,
    s: 0.9534883721,
    lower: 0.8808108966,
    upper: 0.9822847909,
  },
  {
    t: 7.0,
    s: 0.9418604651,
    lower: 0.8659518536,
    upper: 0.9753801313,
  },
  {
    t: 7.1,
    s: 0.9300872093,
    lower: 0.8509831968,
    upper: 0.9679707973,
  },
  {
    t: 7.5,
    s: 0.9183139535,
    lower: 0.8362678267,
    upper: 0.9602012155,
  },
  {
    t: 7.9,
    s: 0.9065406977,
    lower: 0.82178444,
    upper: 0.9521334579,
  },
  {
    t: 8.4,
    s: 0.8947674419,
    lower: 0.8075107353,
    upper: 0.9438123975,
  },
  {
    t: 8.9,
    s: 0.882994186,
    lower: 0.7934265111,
    upper: 0.9352717472,
  },
  {
    t: 9.6,
    s: 0.882994186,
    lower: 0.7934265111,
    upper: 0.9352717472,
  },
  {
    t: 10.5,
    s: 0.8710618322,
    lower: 0.7792456018,
    upper: 0.9264481367,
  },
  {
    t: 10.6,
    s: 0.8591294783,
    lower: 0.7652385072,
    upper: 0.9174459675,
  },
  {
    t: 11.2,
    s: 0.8471971245,
    lower: 0.7513890714,
    upper: 0.9082827008,
  },
  {
    t: 11.4,
    s: 0.8352647706,
    lower: 0.7376839237,
    upper: 0.8989726762,
  },
  {
    t: 12.3,
    s: 0.8352647706,
    lower: 0.7376839237,
    upper: 0.8989726762,
  },
  {
    t: 12.6,
    s: 0.8231594841,
    lower: 0.7238448592,
    upper: 0.8894217594,
  },
  {
    t: 12.8,
    s: 0.8110541975,
    lower: 0.7101413622,
    upper: 0.8797412452,
  },
  {
    t: 12.9,
    s: 0.798948911,
    lower: 0.6965635555,
    upper: 0.8699401458,
  },
  {
    t: 13.0,
    s: 0.7868436245,
    lower: 0.6831030658,
    upper: 0.8600261901,
  },
  {
    t: 13.5,
    s: 0.7747383379,
    lower: 0.6697527265,
    upper: 0.8500060578,
  },
  {
    t: 14.0,
    s: 0.7626330514,
    lower: 0.6565063544,
    upper: 0.8398855606,
  },
  {
    t: 14.3,
    s: 0.7384224783,
    lower: 0.6303047062,
    upper: 0.8193632,
  },
  {
    t: 14.5,
    s: 0.7263171918,
    lower: 0.6173406185,
    upper: 0.8089697575,
  },
  {
    t: 15.0,
    s: 0.7142119053,
    lower: 0.6044626857,
    upper: 0.7984929555,
  },
  {
    t: 15.5,
    s: 0.7021066188,
    lower: 0.5916676995,
    upper: 0.7879359031,
  },
  {
    t: 15.6,
    s: 0.6900013322,
    lower: 0.5789528178,
    upper: 0.7773013684,
  },
  {
    t: 15.8,
    s: 0.6900013322,
    lower: 0.5789528178,
    upper: 0.7773013684,
  },
  {
    t: 15.9,
    s: 0.6900013322,
    lower: 0.5789528178,
    upper: 0.7773013684,
  },
  {
    t: 16.0,
    s: 0.6774558535,
    lower: 0.5657305767,
    upper: 0.7662813024,
  },
  {
    t: 16.3,
    s: 0.6774558535,
    lower: 0.5657305767,
    upper: 0.7662813024,
  },
  {
    t: 17.1,
    s: 0.6646736675,
    lower: 0.5522845134,
    upper: 0.7550138534,
  },
  {
    t: 17.3,
    s: 0.6518914816,
    lower: 0.5389350004,
    upper: 0.7436629989,
  },
  {
    t: 17.7,
    s: 0.6391092957,
    lower: 0.5256786703,
    upper: 0.7322309935,
  },
  {
    t: 18.1,
    s: 0.6263271098,
    lower: 0.512512584,
    upper: 0.7207198316,
  },
  {
    t: 18.5,
    s: 0.6135449239,
    lower: 0.4994341774,
    upper: 0.7091312734,
  },
  {
    t: 18.6,
    s: 0.600762738,
    lower: 0.4864412187,
    upper: 0.697466865,
  },
  {
    t: 18.7,
    s: 0.600762738,
    lower: 0.4864412187,
    upper: 0.697466865,
  },
  {
    t: 19.0,
    s: 0.5874124549,
    lower: 0.472808878,
    upper: 0.6853149879,
  },
  {
    t: 19.1,
    s: 0.5607118888,
    lower: 0.4458444692,
    upper: 0.6607597343,
  },
  {
    t: 19.7,
    s: 0.5473616057,
    lower: 0.4325078342,
    upper: 0.6483587923,
  },
  {
    t: 19.9,
    s: 0.5206610396,
    lower: 0.4061168398,
    upper: 0.6233148619,
  },
  {
    t: 20.5,
    s: 0.5073107565,
    lower: 0.3930598387,
    upper: 0.6106731504,
  },
  {
    t: 20.8,
    s: 0.493599655,
    lower: 0.3796560949,
    upper: 0.5976813806,
  },
  {
    t: 21.1,
    s: 0.4798885535,
    lower: 0.3663545598,
    upper: 0.5846032378,
  },
  {
    t: 21.5,
    s: 0.4661774519,
    lower: 0.3531543883,
    upper: 0.5714388611,
  },
  {
    t: 21.7,
    s: 0.4524663504,
    lower: 0.3400550392,
    upper: 0.5581881909,
  },
  {
    t: 22.1,
    s: 0.4387552489,
    lower: 0.3270562653,
    upper: 0.544850968,
  },
  {
    t: 22.2,
    s: 0.4250441473,
    lower: 0.3141581091,
    upper: 0.5314267309,
  },
  {
    t: 22.5,
    s: 0.4250441473,
    lower: 0.3141581091,
    upper: 0.5314267309,
  },
  {
    t: 22.7,
    s: 0.4108760091,
    lower: 0.3008277572,
    upper: 0.5175650719,
  },
  {
    t: 23.1,
    s: 0.3967078709,
    lower: 0.2876150848,
    upper: 0.5036043907,
  },
  {
    t: 23.2,
    s: 0.3825397326,
    lower: 0.2745207018,
    upper: 0.4895435657,
  },
  {
    t: 23.4,
    s: 0.3683715944,
    lower: 0.2615456221,
    upper: 0.4753811808,
  },
  {
    t: 24.9,
    s: 0.3542034561,
    lower: 0.2486912794,
    upper: 0.461115505,
  },
  {
    t: 25.0,
    s: 0.3400353179,
    lower: 0.2359595506,
    upper: 0.4467444672,
  },
  {
    t: 25.2,
    s: 0.3400353179,
    lower: 0.2359595506,
    upper: 0.4467444672,
  },
  {
    t: 25.5,
    s: 0.3400353179,
    lower: 0.2359595506,
    upper: 0.4467444672,
  },
  {
    t: 25.7,
    s: 0.3400353179,
    lower: 0.2359595506,
    upper: 0.4467444672,
  },
  {
    t: 25.9,
    s: 0.3238431599,
    lower: 0.2210462856,
    upper: 0.4307490679,
  },
  {
    t: 28.7,
    s: 0.3076510019,
    lower: 0.2063598453,
    upper: 0.4145762886,
  },
  {
    t: 28.8,
    s: 0.2914588439,
    lower: 0.1919029082,
    upper: 0.3982220637,
  },
  {
    t: 29.8,
    s: 0.2752666859,
    lower: 0.1776796701,
    upper: 0.3816811867,
  },
  {
    t: 30.3,
    s: 0.2752666859,
    lower: 0.1776796701,
    upper: 0.3816811867,
  },
  {
    t: 30.6,
    s: 0.258062518,
    lower: 0.1625714909,
    upper: 0.3642167493,
  },
  {
    t: 30.7,
    s: 0.258062518,
    lower: 0.1625714909,
    upper: 0.3642167493,
  },
  {
    t: 30.8,
    s: 0.258062518,
    lower: 0.1625714909,
    upper: 0.3642167493,
  },
  {
    t: 30.9,
    s: 0.2382115551,
    lower: 0.1447820441,
    upper: 0.344741052,
  },
  {
    t: 31.5,
    s: 0.2382115551,
    lower: 0.1447820441,
    upper: 0.344741052,
  },
  {
    t: 32.1,
    s: 0.2143903996,
    lower: 0.1229457556,
    upper: 0.3225754156,
  },
  {
    t: 32.8,
    s: 0.1905692441,
    lower: 0.1023410315,
    upper: 0.2995119243,
  },
  {
    t: 32.9,
    s: 0.1905692441,
    lower: 0.1023410315,
    upper: 0.2995119243,
  },
  {
    t: 34.5,
    s: 0.1633450664,
    lower: 0.0792658055,
    upper: 0.2738775109,
  },
  {
    t: 37.1,
    s: 0.1361208886,
    lower: 0.0583590619,
    upper: 0.2466590976,
  },
  {
    t: 37.3,
    s: 0.1088967109,
    lower: 0.0397446209,
    upper: 0.2177484823,
  },
  {
    t: 43.6,
    s: 0.0816725332,
    lower: 0.023710425,
    upper: 0.1869266159,
  },
  {
    t: 44.3,
    s: 0.0816725332,
    lower: 0.023710425,
    upper: 0.1869266159,
  },
  {
    t: 48.5,
    s: 0.0816725332,
    lower: 0.023710425,
    upper: 0.1869266159,
  },
  {
    t: 62.3,
    s: 0.0816725332,
    lower: 0.023710425,
    upper: 0.1869266159,
  },
];

export default OS_LOW_RISK_DATA;
